var LinkBehaviour = /* @__PURE__ */ ((LinkBehaviour2) => {
  LinkBehaviour2["NewWindow"] = "NEW_WINDOW";
  LinkBehaviour2["Standard"] = "STANDARD";
  return LinkBehaviour2;
})(LinkBehaviour || {});

export { LinkBehaviour };
//# sourceMappingURL=shared.js.map
